import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { ButtonController } from '../../../Common/ButtonController';
import { GameModel } from '../../../Models/GameModel';
import { LocalizationContents } from '../../../LocalizationContents';
import {
    GreenButtonTextStyle,
    TitleTextStyle,
    YellowTextBoldStyle,
    YellowTextStyle,
} from '../../../Constants/TextStyles';

export interface IConfirmationsGetPrizeControllerOptions {
    text?: 'A you sure?',
    value: 1000;
    receiveText?: 'GET',
    receiveClick?: () => {}
    exitClick?: () => {}
}

export class ConfirmationsGetPrizeController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: IConfirmationsGetPrizeControllerOptions,
    ) {
        super('ConfirmationsGetPrizeController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.CONFIRMATIONS_JSON,
            libraryName: 'confirmations_container',
            childControllers: {
                get_prize_ok: {
                    controller: ButtonController,
                    instanceName: 'confirmations.get_prize.get_prize_ok',
                    options: {
                        label: this._options.receiveText || '',
                        onClick: () => {
                            if (this._options.receiveClick) {
                                this._options.receiveClick();
                            }
                        },
                    },
                },
                get_prize_exit: {
                    controller: ButtonController,
                    instanceName: 'confirmations.get_prize.get_prize_exit',
                    options: {
                        onClick: () => {
                            if (this._options.receiveClick) {
                                this._options.receiveClick();
                                return;
                            }
                            if (this._options.exitClick) {
                                this._options.exitClick();
                            }
                        },
                    },
                },
            },
        };
    }

    protected onInitialize() {
        this.init();
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    public init(): void {
        this.gotoAndStopByQuery('confirmations', 'get_prize');
        this.setTextByQuery('confirmations.get_prize.get_prize_title', this._options.text || LocalizationContents.getText('ReceiveGiftTitle'));
        this.setTextStyleByQuery('confirmations.get_prize.get_prize_title', TitleTextStyle);
        this.setTextVerticalAlignByQuery('confirmations.get_prize.get_prize_title', 'middle');

        this.setTextByQuery('confirmations.get_prize.get_prize_text', `x${this._options.value ? this._options.value.toString() : '1000'}`);
        this.setTextStyleByQuery('confirmations.get_prize.get_prize_text', YellowTextBoldStyle);

        this.setTextByQuery('confirmations.get_prize.get_prize_ok.label', this._options.receiveText || '');
        this.setTextByQuery('confirmations.get_prize.get_prize_ok.txt_price', this._options.receiveText || '');

        this.setTextStyleByQuery('confirmations.get_prize.get_prize_ok.label', GreenButtonTextStyle);
        this.setTextStyleByQuery('confirmations.get_prize.get_prize_ok.txt_price', GreenButtonTextStyle);
    }
}
